import React, { useEffect, useRef, useState, useCallback, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Button,
  Card,
  Form,
  FormControl,
  FormLabel,
  InputGroup,
  Modal,
} from 'react-bootstrap';
import infiniteLoop from "../../../../assets/img/animated-icons/infinite-loop.json";
import {

  faSave,
  faRedo,

  faEraser,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import {
  matchPath,
  useLocation,
  useNavigate,
  useParams,
} from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';

import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useAsyncDebounce } from 'react-table';
import { bulkPaymentProcessConfig, fetchAddressSuggestions2, getBulkPaymentProcessConfig } from '../actions/instruction';
import { getCountryList } from '../../registration/actions/Registration';
import { updateSelectedAddressResult } from '../../blRequestInstruction/components/instructionSlice/CarrierHaulageSlice';
import { InstructionList } from '../types';
import {
 
  getBulkfileExtensionList,
  getAllowMultipleCountryList,
  getActiveInactiveList,
} from '../../blRequestInstruction/components/actions/Instruction';

import { AESDecrypt, AESDecryptAny } from '../../../../encrypt-util';
import SoftBadge from '../../../../components/common/SoftBadge';
import {
  faArrowAltCircleLeft,
  faEdit,
} from '@fortawesome/free-regular-svg-icons';

import { commonApproveReject } from '../actions/instruction';

import Lottie from 'lottie-react';
import { clearFields } from '../../blRequestInstruction/components/instructionSlice/AgentNominationSlice';
import { updateDashbaordRefresh } from '../../../common/components/DataTable/slices/DataTable';
import { useBackNavigation } from '../../../../hooks/BackNavigation';
import { RootState,AppDispatch } from '../../template/store';
import { MultiSelect } from 'react-multi-select-component';
import Select from 'react-select';
import { useFormNavigationWarning } from '../../../../hooks/useFormNavigationWarning';
import UnsavedChangesModal from '../../../../components/common/UnsavedChangesModal';
import { setDirty } from '../../formDirtySlice';

// Add interface for dropdown options
interface SelectOption {
  value: string | number;
  text: string;
}

const BulkPayment = () => {


const { bulk_payment_process_config_id} = useParams();
  const bulkPaymentProcessConfigId = bulk_payment_process_config_id ? AESDecrypt(bulk_payment_process_config_id) : undefined;
  

  const [clearable, setClearable] = useState(true);
const[bulkfileExtensionList,setBulkfileExtensionList]=useState<SelectOption[]>([])
const[allowMultipleCountryList,setAllowMultipleCountryList]=useState<SelectOption[]>([])
const[isActiveList,setIsActiveList]=useState<SelectOption[]>([])
const[loading,setLoading]=useState(false)
  // const dataCountry = useSelector(
  //   (state: RootState) => state.userProfile.linerDataCountry
  // );
   const isDirty = useSelector((state:RootState) => state.formDirty.isDirty);
  const profileDetails = useSelector(
    (state: RootState) => state.userProfile.profile
  );
  const linerDataCountry = useSelector(
    (state: RootState) => state.userProfile.linerDataCountry
  );
  const storedUserCountry =
    AESDecryptAny(window.localStorage.getItem('@user-selected-datacountry')) || [];
  const storedCountry =
    storedUserCountry?.[0]?.loginId === profileDetails.email
      ? storedUserCountry?.[0]?.country
      : null;
  const dataCountry = storedCountry
    ? storedCountry
    : linerDataCountry
    ? linerDataCountry
    : profileDetails.partnerCountry || null;

  const selectedRouter = useSelector(
    (state: RootState) => state.documentHistory.selectedRouter
  );
  const { t } = useTranslation();

  const dispatch = useDispatch<AppDispatch>();

  const location = useLocation();
  // const docId = location.pathname.split('/')[4];

  const navigate = useNavigate();

  const onBack = useBackNavigation();
  const [submitEnable, setSubmitEnable] = useState(false);

  const matchPathInstruction = () =>
    Boolean(matchPath(
      {
        path: "/bulkpaymentDashboard/bulkpayment/:bulk_payment_process_config_id",
        caseSensitive: true,
        end: true,
      },
      location.pathname
    ));

  useEffect(()=>{
    if (!matchPathInstruction()) {
      dispatch(getBulkfileExtensionList('US')).unwrap()
        .then((response: any) => {
          setBulkfileExtensionList(response)
          setValue("bulkfileExtension", []); // Set empty value to show select option
        })
      dispatch(getAllowMultipleCountryList('US')).unwrap()
        .then((response: any) => {
          setAllowMultipleCountryList(response)
          if (response && response.length > 0) {
            setValue("allowMultipleCountry", response[0].value);
          }
        })
    } else {
      dispatch(getBulkfileExtensionList('US')).unwrap()
        .then((response: any) => {
          setBulkfileExtensionList(response)
        })
      dispatch(getAllowMultipleCountryList('US')).unwrap()
        .then((response: any) => {
          setAllowMultipleCountryList(response)
        })
    }
  }, [matchPathInstruction()])

  const resetForm = () => {
    setLoading(false)
    reset()
  };

  type FormValues = {
    customerName: string;
    emailFrom: string;
    bulkfileExtension: string[];
    transactionStartFromRow: string;
    defaultPaymentReference: string;
    noOfBlankRecordeSkip: string;
    sheetNo: string;
    invoiceNoRecordSequence: string;
    invoiceAmountRecordSequence: string;
    paymentReferenceRecordSequence: string;
    allowMultipleCountry: string;
    isActive: string;
    bulkResponceonEmail: string;
    dataSepratorforCSV: string;
  };

const validationSchema: Yup.ObjectSchema<any> = Yup.object()
  .shape({
    customerName: Yup.string().required(
      t('resource_3:isRequired', { field: t('resource_2:customerName') })
    ),

    emailFrom: Yup.string()
      .required('Email is required')
      .test('is-valid-emails', 'One or more emails are invalid', value => {
        if (!value) return false;
        return value
          .split(',')
          .map(e => e.trim())
          .every(email => !email || Yup.string().email().isValidSync(email));
      }),

    transactionStartFromRow: Yup.number()
      .typeError(
        t('resource_3:isRequired', { field: t('resource_3:transaction_row_start') })
      )
      .required(
        t('resource_3:isRequired', { field: t('resource_3:transaction_row_start') })
      )
      .min(1, 'Minimum value must be 1')
      .transform((value, originalValue) =>
        originalValue === '' ? null : Number(originalValue)
      ),

    invoiceNoRecordSequence: Yup.string()
      .required(t('resource_3:isRequired', { field: t('resource_4:inv_no_column_id') })),

    noOfBlankRecordeSkip: Yup.string().required(
      t('resource_3:isRequired', { field: t('resource_5:noOfBlankRecordeSkip') })
    ),

    // sheetNo: Yup.string().required(
    //   t('resource_3:isRequired', { field: t('resource_2:sheetNo') })
    // ),

    sheetNo: Yup.string().when('bulkfileExtension', {
      is: (val:any) => val?.includes('xls') || val?.includes('xlsx'),
      then: Yup.string().required(
        t('resource_3:isRequired', { field: t('resource_2:sheetNo') })
      ),
      otherwise: Yup.string().nullable(), // or .notRequired()
    }),


    invoiceAmountRecordSequence: Yup.number()
      .typeError(t('resource_3:isRequired', { field: t("resource_4:inv_amt_column_id") }))
      .required(t('resource_3:isRequired', { field: t("resource_4:inv_amt_column_id") }))
      .min(1, 'Minimum value must be 1')
      .transform((value, originalValue) =>
        originalValue === '' ? null : Number(originalValue)
      ),

    paymentReferenceRecordSequence: Yup.string()
      .nullable()
      .transform(value => (value === '' ? null : value))
      .matches(/^[1-9]\d*$/, 'Only positive integers allowed'),

    defaultPaymentReference: Yup.string()
      .nullable()
      .max(100, 'Maximum 100 characters allowed')
      .transform(value => (value === '' ? null : value)),

    bulkResponceonEmail: Yup.string()
      .test('is-valid-emails', 'One or more emails are invalid', value => {
        if (!value) return true; // allow empty
        return value
          .split(',')
          .map(e => e.trim())
          .every(email => !email || Yup.string().email().isValidSync(email));
      }),
    bulkfileExtension: Yup.array().of(Yup.string()).required(
      t('resource_3:isRequired', { field: t('resource_3:bulkFileExtension') })
    ),
    dataSepratorforCSV: Yup.string().when('bulkfileExtension', {
      is: (val: string[]) => Array.isArray(val) && val.some(ext => ext.toLowerCase() === 'csv'),
      then: (schema) => schema.required(t('resource_3:isRequired', { field: t("resource_4:dataSeperatorForCsv") })),
      otherwise: (schema) => schema.nullable()
    })
  })

  // ✅ Ensure one of paymentReferenceRecordSequence or defaultPaymentReference is provided
  .test(
    'at-least-one-payment-field',
    'Either Payment Reference Column or Default Payment Reference is required',
    function (values) {
      const { paymentReferenceRecordSequence, defaultPaymentReference } = values || {};
      const hasPRR = !!paymentReferenceRecordSequence?.trim();
      const hasDPR = !!defaultPaymentReference?.trim();

      if (!hasPRR && !hasDPR) {
        return this.createError({
          path: 'paymentReferenceRecordSequence',
          message: 'Either Payment Reference Column or Default Payment Reference is required',
        });
      }
      return true;
    }
  );

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    trigger,
    formState: { errors, touchedFields },
    watch,
    clearErrors,
    setError
  } = useForm<FormValues>({
    resolver: yupResolver(validationSchema),
   
    mode: 'onChange',
  });

  // useMemo to sort isActive options dynamically - MOVED HERE after watch and matchPathInstruction declarations
  const sortedIsActiveOptions = useMemo(() => {
    if (!isActiveList || isActiveList.length === 0) {
      return [];
    }

    const currentIsActiveWatchValue = watch('isActive');
    
    const selectedOption = isActiveList.find(option => String(option.value) === String(currentIsActiveWatchValue));

    if (selectedOption && !(matchPathInstruction() && !submitEnable)) {
        const remainingOptions = isActiveList.filter(option => String(option.value) !== String(currentIsActiveWatchValue));
        return [selectedOption, ...remainingOptions];
    }

    return isActiveList;
  }, [isActiveList, watch('isActive'), matchPathInstruction, submitEnable]);
const { showModal, handleNavigation, handleConfirm, handleCancel, handleBack } = useFormNavigationWarning({
  isChanged: isDirty,
  isEditable: true,
  onConfirm:  onBack // or onBack, or your navigation function
});
  
    const handleStayOnPage = () => {
      handleCancel();
    };
      const onBackForm = () => {
        navigate('/bulkpaymentDashboard')
      };
  
 

    const handleLeavePage = () => {
    //  onBack()
         const APP_PATH_PREFIX = process.env.REACT_APP_APP_PATH_PREFIX || '';
    navigate(`${APP_PATH_PREFIX}/bulkpaymentDashboard`)
    };
  useEffect(() => {
    if(matchPathInstruction()){
      setSubmitEnable(false)
      clearErrors()
      if (bulkPaymentProcessConfigId) {
        dispatch(getBulkPaymentProcessConfig(bulkPaymentProcessConfigId)).unwrap()
        .then((configResponse: any) => {
          setValue("customerName", configResponse.customerName);
          setValue("emailFrom", configResponse.emailFrom);
          setValue('bulkfileExtension', configResponse.fileExtension?.split(',') || []);
          
          const allowMultipleCountryOption: any = allowMultipleCountryList.find(
            (item: any) => {
              if (configResponse.allowMultipleCountry === 'Y') {
                return item.value === 1;
              } else if (configResponse.allowMultipleCountry === 'N') {
                return item.value === 0;
              }
              return false;
            }
          );
          if (allowMultipleCountryOption) {
            setValue('allowMultipleCountry', allowMultipleCountryOption.value);
          } else {
            setValue('allowMultipleCountry', '');
          }

          setValue('noOfBlankRecordeSkip', configResponse.skipBlankRowNo);
          setValue('sheetNo', configResponse?.sheetNo);
          setValue('transactionStartFromRow', configResponse.transactionRowStart);
          setValue('defaultPaymentReference', configResponse.defaultPmtRefNo);
          setValue('invoiceAmountRecordSequence', configResponse.invAmtColumnId);
          setValue('invoiceNoRecordSequence', configResponse.invNoColumnId);
          setValue('bulkResponceonEmail', configResponse.responseToEmail);
          setValue('dataSepratorforCSV', configResponse.separator);
          setValue('paymentReferenceRecordSequence', configResponse.pmtRefColumnId);

          const initialIsActiveValue: boolean = configResponse.isActive;

          dispatch(getActiveInactiveList('US')).unwrap()
            .then((activeInactiveListResponse: SelectOption[]) => {
              setIsActiveList(activeInactiveListResponse);

              let matchedOptionValue: string | number | undefined;
              if (initialIsActiveValue === true) {
                matchedOptionValue = activeInactiveListResponse.find((option: SelectOption) => option.value === 1)?.value;
              } else if (initialIsActiveValue === false) {
                matchedOptionValue = activeInactiveListResponse.find((option: SelectOption) => option.value === 0)?.value;
              }

              if (matchedOptionValue !== undefined) {
                setValue("isActive", String(matchedOptionValue));
              } else if (activeInactiveListResponse.length > 0) {
                setValue("isActive", String(activeInactiveListResponse[0].value));
              } else {
                setValue("isActive", "");
              }
            })
            .catch((error: any) => {
              console.error("Error fetching active inactive list:", error);
              toast.error("Error fetching active/inactive options.");
            });
        })
        .catch((error: any) => {
          console.error("Error fetching bulk payment config:", error);
          toast.error("Error loading bulk payment configuration.");
        });
      }
    } else {
      reset();
    }
  }, [bulkPaymentProcessConfigId]);

  const _onCloseForm = () => {
    setLoading(false)
  navigate('/bulkpaymentDashboard')
  };

  const onSubmit = handleSubmit(
    async (payload: any) => {
      console.log("idhere",bulkPaymentProcessConfigId)
      try {
      const payloadData={
          "customerName": payload.customerName,
          "emailFrom": payload.emailFrom,
         "fileExtension": Array.isArray(payload.bulkfileExtension) ? payload.bulkfileExtension.join(',') : payload.bulkfileExtension,
          "transactionRowStart": payload.transactionStartFromRow,
          "invNoColumnId": payload.invoiceNoRecordSequence,
          "invAmtColumnId": payload.invoiceAmountRecordSequence,
          "pmtRefColumnId": payload.paymentReferenceRecordSequence?payload.paymentReferenceRecordSequence:null,
          "defaultPmtRefNo": payload.defaultPaymentReference? payload.defaultPaymentReference:null,
          "skipBlankRowNo": payload.noOfBlankRecordeSkip,
          "sheetNo": payload.sheetNo,
          "separator": Array.isArray(payload.bulkfileExtension) && payload.bulkfileExtension.some((ext:any) => ext.toLowerCase() === 'csv') ? payload.dataSepratorforCSV : "",
          "allowMultipleCountry":/*  payload.allowMultipleCountry == "1"?"Y": */"N",
          "responseToEmail": payload.bulkResponceonEmail,
          "isActive":  payload.isActive ?payload.isActive === "1":"true",
          "country": "US",
          "linerId": "1"
        }
        var payloadNew
        if (bulkPaymentProcessConfigId) {
          payloadNew = {
            ...payloadData,
            bulkPaymentProcessConfigId
          }
        } else {
          payloadNew = {
            ...payloadData
          }
        }
        dispatch(bulkPaymentProcessConfig(payloadNew))  .unwrap()
        .then((response: any) => {
          if(response.status)
          setLoading(true)
          console.log("payloaddd",payload)
          toast.success(response?.message);
          if(response?.message.includes('added successfully') || response?.message.includes('updated successfully'))
          setTimeout(() => {
            _onCloseForm() 
            setTimeout(() => {
              dispatch(updateDashbaordRefresh(true));
            }, 2000);
          }, 500);
        })
     
      } catch (err: any) {
        console.error(err.message);
        setLoading(false)
      }
    }
  );






  return (
    <Card style={{ height: '100%', overflow:'auto' }}>
                <UnsavedChangesModal
              show={showModal}
              onHide={handleStayOnPage}
              onConfirm={handleLeavePage}
            />
      <Card.Header className='border-bottom d-flex justify-content-between align-items-center'>
        <FontAwesomeIcon
          icon={faArrowAltCircleLeft}
          className='text-warning cursor-pointer fa-lg mb-1'
        //  onClick={_onCloseForm}
         onClick={onBackForm}
        />
 
          <div className='row col-12'>
            <div className='col-lg-4'>
              <h2 className='fs-0 text-primary'>
                {' '}
                {t("resource_2:bulkPayment")}
              </h2>
            </div>
          </div>
      
 
      </Card.Header>

      <Card.Body>
        <div className='container'>
        
          <Form onSubmit={onSubmit} autoComplete='off'>
            <div className='row'>
              <div className='col-lg-12'>
        
            
      

                <div className='row'>
                  <div className='col-lg-6 '>
                    <Form.Group controlId='bulk.customerName'>
                    <span className='mandatory'>*</span>
                      <Form.Label>   {t("resource_2:customerName")}</Form.Label>
                      <div className='row'>
                        <div className='col-lg-12 mb-1'>
                          <Form.Control
                            size='sm'
                            {...register('customerName')}
                            className={`fs--1 col-lg-12 mb-1 form-control ${
                              errors.customerName ? 'is-invalid' : ''
                            }`}
                            type='text'
                            onChange={(e) =>
                             {
                              setValue(
                                'customerName',
                                e.target.value.trim(),{ shouldValidate: true }
                              )
                          dispatch(setDirty())
                              clearErrors("customerName");
                            }
                            }
                            value={watch('customerName')}
                            maxLength={200}
                           
                            disabled={
                              matchPathInstruction() && !submitEnable?true:false
                            }
                          />
                          <div className='invalid-feedback'>
                            {errors.customerName?.message?.toString()}
                          </div>
                        </div>
                    
                      </div>
                    </Form.Group>
                  </div>
                  <div className='col-lg-6 '>
                    <Form.Group controlId='bulk.pol'>
                    <span className='mandatory'>*</span>
                      <Form.Label>
                        {/* <span className='mandatory'>*</span> */}
                        {t("resource_2:email_from")}
                      </Form.Label>
                      <div className='row'>
                        <div className='col-lg-12 mb-1'>
                          <Form.Control
                            size='sm'
                            {...register('emailFrom')}
                            className={`fs--1 form-control ${errors.emailFrom ? 'is-invalid' : ''}`}
                            type='text'
                            onChange={(e) => {
                              setValue('emailFrom', e.target.value.trim(), { shouldValidate: true });
                              clearErrors('emailFrom');
                                    dispatch(setDirty())
                            }}
                            value={watch('emailFrom')}
                            disabled={matchPathInstruction() && !submitEnable ? true : false}
                          />
                        {/*   <small className='text-muted'>You can enter multiple emails separated by commas.</small> */}
                          <div className='invalid-feedback'>
                            {errors.emailFrom?.message?.toString()}
                          </div>
                        </div>
                    
                      </div>
                    </Form.Group>
                  </div>
<div className='col-lg-6'>
  <Form.Group className="mb-3" controlId="bulkfileExtension">
    <Form.Label>
      <span className='mandatory'>*</span>
      {t('resource_3:bulkFileExtension')}
    </Form.Label>
    {matchPathInstruction() && !submitEnable ? (
      <Form.Control
        type="text"
        value={watch('bulkfileExtension')?.join(', ') || ''}
        disabled={true}
        className="form-control"
      />
    ) : (
      <Select
        isMulti
        isSearchable
        options={bulkfileExtensionList.map((item: any) => ({
          value: item.text,
          label: item.text,
        }))}
        onChange={(selectedOptions: any) => {
          const values = selectedOptions ? selectedOptions.map((i: any) => i.value) : [];
          setValue('bulkfileExtension', values, { shouldValidate: true });
          clearErrors('bulkfileExtension');
          if (values.length === 0) {
            setValue('dataSepratorforCSV', '');
          }
                dispatch(setDirty())
        }}
        value={(watch('bulkfileExtension') || []).map((val: string) => ({ value: val, label: val }))}
        className={`fs--1 ${errors.bulkfileExtension ? 'is-invalid' : ''}`}
        classNames={{
          control: (state) =>
            `fs--1 m-0 p-0 asyncDropField ${state.isDisabled ? '' : 'dropControl form-control'} ${state.isFocused ? 'focusField' : ''}`,
        }}
        styles={{
          control: (base, state) => ({
            ...base,
            fontSize: '16px',
            padding: '0 10px',
            minHeight: 'auto',
            height: 'auto',
            maxHeight: '100%',
            border: state.isFocused ? '1px solid #007bff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.2rem rgba(0, 123, 255, 0.25)' : 'none',
          }),
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          dropdownIndicator: (base, state) =>
            state.isDisabled ? { display: 'none' } : { ...base },
        }}
        menuPortalTarget={typeof window !== 'undefined' ? document.body : undefined}
        noOptionsMessage={() => 'No extension'}
      />
    )}
    <div className="invalid-feedback">
      {errors.bulkfileExtension?.message}
    </div>
  </Form.Group>
</div>
                 

                  <div className='col-lg-6 '>
  <Form.Group controlId='bulk.transaction'>
    <span className='mandatory'>*</span>
    <Form.Label>{t("resource_3:transaction_row_start")}</Form.Label>
    <div className='row'>
      <div className='col-lg-12 mb-1'>
     <Form.Control
  size='sm'
  {...register('transactionStartFromRow')}
  className={`fs--1 form-control ${
    errors.transactionStartFromRow ? 'is-invalid' : ''
  }`}
  type='number'
  onChange={(e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && (value === '' || parseInt(value, 10) >= 1)) {
      setValue('transactionStartFromRow', value, { shouldValidate: true });
      clearErrors('transactionStartFromRow');
    }
          dispatch(setDirty())
  }}
  value={watch('transactionStartFromRow')}
  disabled={matchPathInstruction() && !submitEnable}
/>
        <div className='invalid-feedback'>
          {errors.transactionStartFromRow?.message?.toString()}
        </div>
      </div>
    </div>
  </Form.Group>
</div>

              

              <div className='col-lg-6 mb-3' style={{ zIndex: 501 }}>
                <Form.Group controlId='bulk.default'>
                  <Form.Label className='fs--1'>
                    <span className='mandatory'>*</span>
           
                    {t("resource_3:defaultPaymentReference")}
                  </Form.Label>
                  <div className='row'>
                        <div className='col-lg-12 mb-1'>
                          <Form.Control
                            size='sm'
                            {...register('defaultPaymentReference')}
                            className={`fs--1 form-control ${
                              errors.defaultPaymentReference ? 'is-invalid' : ''
                            }`}
                            type='text'
                            onChange={(e) =>
                            {
                              setValue(
                                'defaultPaymentReference',
                                e.target.value,{ shouldValidate: true }
                              )
                                    dispatch(setDirty())
                              clearErrors('defaultPaymentReference')
                            }
                            }
                            value={watch('defaultPaymentReference')}
                            maxLength={100}
                            disabled={      matchPathInstruction()&& !submitEnable?true:false}
                         
                          />
                          <div className='invalid-feedback'>
                            {errors.defaultPaymentReference?.message?.toString()}
                          </div>
                        </div>
                    
                      </div>
                </Form.Group>
              </div>

              <div className='col-lg-4 mb-3' style={{ zIndex: 501 }}>
                <Form.Group controlId='bulk.validTill'>
                  <Form.Label className='fs--1'>
                    <span className='mandatory'>*</span>
                 
                    {t("resource_5:noOfBlankRecordeSkip")}
                  </Form.Label>
                  <div className='row'>
                        <div className='col-lg-12 mb-1'>
                          <Form.Control
                            size='sm'
                            {...register('noOfBlankRecordeSkip')}
                            className={`fs--1 form-control ${
                              errors.noOfBlankRecordeSkip ? 'is-invalid' : ''
                            }`}
                            type='Number'
                            onChange={(e) => {
                              {
                              const value = e.target.value;
                              if (/^\d*$/.test(value)) {
                                setValue('noOfBlankRecordeSkip', value,{ shouldValidate: true });
                              }
                              clearErrors('noOfBlankRecordeSkip')
                                    dispatch(setDirty())
                            }
                            }}
                            value={watch('noOfBlankRecordeSkip')}
                     
                            disabled={      matchPathInstruction()&& !submitEnable?true:false}
                           
                         
                          />
                          <div className='invalid-feedback'>
                            {errors.noOfBlankRecordeSkip?.message?.toString()}
                          </div>
                        </div>
                    
                      </div>

                </Form.Group>
              </div>

          

        
             <div className='col-lg-6 mb-3'>
  <Form.Group controlId='bulk.invoice'>

    <Form.Label>
      <span className='mandatory'>*</span>
      {t("resource_4:inv_no_column_id")}
    </Form.Label>

    <Form.Control
      size='sm'
      {...register('invoiceNoRecordSequence', {
        required: 'Invoice number record sequence is required',
        min: {
          value: 1,
          message: 'Minimum value must be 1',
        },
        pattern: {
          value: /^[1-9]\d*$/, // Only positive integers starting from 1
          message: 'Only positive integers allowed',
        }
      })}
      className={`fs--1 form-control ${
        errors.invoiceNoRecordSequence ? 'is-invalid' : ''
      }`}
      type='number'
      onChange={(e) => {
        const value = e.target.value;
        // Allow only digits and value >= 1
        if (/^\d*$/.test(value) && (value === '' || parseInt(value, 10) >= 1)) {
          setValue('invoiceNoRecordSequence', value, { shouldValidate: true });
          clearErrors('invoiceNoRecordSequence');
        }
              dispatch(setDirty())
      }}
      value={watch('invoiceNoRecordSequence')}
      disabled={matchPathInstruction() && !submitEnable}
    />

    <div className='invalid-feedback'>
      {errors.invoiceNoRecordSequence?.message?.toString()}
    </div>
  </Form.Group>
</div>

             <div className='col-lg-6 mb-3'>
  <Form.Group controlId='bulk.amount'>
    <Form.Label>
      <span className='mandatory'>*</span>
      {t("resource_4:inv_amt_column_id")}
    </Form.Label>

  <Form.Control
  size='sm'
  {...register('invoiceAmountRecordSequence', {
    required: t('resource_3:isRequired', { field: t("resource_4:inv_amt_column_id") })
  })}
  className={`fs--1 form-control ${
    errors.invoiceAmountRecordSequence ? 'is-invalid' : ''
  }`}
  type='number'
  onChange={(e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value) && (value === '' || parseInt(value, 10) >= 1)) {
      setValue('invoiceAmountRecordSequence', value, { shouldValidate: true });
      clearErrors('invoiceAmountRecordSequence');
    }
          dispatch(setDirty())
  }}
  value={watch('invoiceAmountRecordSequence')}
  disabled={matchPathInstruction() && !submitEnable}
/>


    <div className='invalid-feedback'>
      {errors.invoiceAmountRecordSequence?.message?.toString()}
    </div>
  </Form.Group>
</div>
<div className='col-lg-6 mb-3'>
  <Form.Group controlId='bulk.paymentref'>
    <Form.Label>
      <span className='mandatory'>*</span>
      {t('resource_4:pmt_ref_column_id')}
    </Form.Label>

    <Form.Control
      size='sm'
      {...register('paymentReferenceRecordSequence', {
        min: {
          value: 1,
          message: 'Minimum value must be 1',
        },
        pattern: {
          value: /^[1-9]\d*$/, // must be positive integer, no zero or negative
          message: 'Only positive integers allowed',
        },
      })}
      className={`fs--1 form-control ${
        errors.paymentReferenceRecordSequence ? 'is-invalid' : ''
      }`}
      type='number'
      onChange={(e) => {
        const value = e.target.value;
        if (/^\d*$/.test(value) && (value === '' || parseInt(value, 10) >= 1)) {
          setValue('paymentReferenceRecordSequence', value, { shouldValidate: true });
        }
        clearErrors('paymentReferenceRecordSequence');
              dispatch(setDirty())
      }}
      value={watch('paymentReferenceRecordSequence')}
      disabled={matchPathInstruction() && !submitEnable}
    />

    <div className='invalid-feedback'>
      {errors.paymentReferenceRecordSequence?.message?.toString()}
    </div>
  </Form.Group>
</div>

         {/*  
              <div className='col-lg-6 mb-3'>
                <Form.Group
                 
                  controlId='bulk.allow'>
                  <Form.Label>

            
                    {t("resource_3:allow_multiple_country")}
                  </Form.Label>
                  <Form.Select
                    {...register("allowMultipleCountry")}
                    value={watch("allowMultipleCountry")}
                    onChange={(e) => {
                      setValue("allowMultipleCountry", e.target.value, { shouldValidate: true });
                      clearErrors("allowMultipleCountry");
                    }}
                    className={`fs--1 ${errors?.allowMultipleCountry ? "is-invalid" : ""}`}
                    disabled={matchPathInstruction() && !submitEnable}
                  >
             
                    {allowMultipleCountryList.map((option: SelectOption) => (
                      <option key={String(option.value)} value={String(option.value)}>
                        {option.text}
                      </option>
                    ))}
                  </Form.Select>
                  <div className='invalid-feedback'>
                    {errors.allowMultipleCountry?.message?.toString()}
                  </div>

            
                </Form.Group>
              </div> */}
              {  matchPathInstruction() &&
              <div className='col-lg-6 mb-3'>
                <Form.Group
                 
                  controlId='bulk.active'>
                  <Form.Label>

            
                    {t("resource_1:status")}
                  </Form.Label>
                  <Form.Select
                    {...register("isActive")}
                    onChange={(e: any) => {
                      setValue("isActive", e.target.value,{ shouldValidate: true } );
                      clearErrors("isActive");
                            dispatch(setDirty())
                    }}
                    value={
                      watch("isActive")
                    }
                    disabled={      matchPathInstruction()&& !submitEnable?true:false}
                    className={`fs--1 ${errors?.isActive ? "is-invalid" : ""}`}
                  >
                 
                    { (matchPathInstruction() && !submitEnable)
                      ? isActiveList.map((option: SelectOption) => (
                          <option key={String(option.value)} value={String(option.value)}>
                            {option.text}
                          </option>
                        ))
                      : sortedIsActiveOptions.map((option: SelectOption) => (
                          <option key={String(option.value)} value={String(option.value)}>
                            {option.text}
                          </option>
                        ))
                    }
                  </Form.Select>
                  <div className='invalid-feedback'>
                    {errors.isActive?.message?.toString()}
                  </div>

            
                </Form.Group>
              </div>}
              <div className='col-lg-6 mb-3'>
                <Form.Group
                 
                  controlId='bulk.email'>
                  <Form.Label>
      
            
                    {t("resource_3:response_to_email")}
                  </Form.Label>
                  <Form.Control
                    size='sm'
                    {...register('bulkResponceonEmail')}
                    className={`fs--1 form-control ${errors.bulkResponceonEmail ? 'is-invalid' : ''}`}
                    type='text'
                    onChange={(e) => {
                      setValue('bulkResponceonEmail', e.target.value, { shouldValidate: true });
                      clearErrors('bulkResponceonEmail');
                            dispatch(setDirty())
                    }}
                    disabled={matchPathInstruction() && !submitEnable ? true : false}
                    value={watch('bulkResponceonEmail')}
                  />
                  {/* <small className='text-muted'>You can enter multiple emails separated by commas.</small> */}
                  <div className='invalid-feedback'>
                    {errors.bulkResponceonEmail?.message?.toString()}
                  </div>

            
                </Form.Group>
              </div>
                {Array.isArray(watch('bulkfileExtension')) && watch('bulkfileExtension').some(ext => ext.toLowerCase() === 'csv') && (
              <div className='col-lg-6 mb-3'>
                <Form.Group
                 
                  controlId='bulk.csv'>
                  <Form.Label>
                    {Array.isArray(watch('bulkfileExtension')) && watch('bulkfileExtension').some(ext => ext.toLowerCase() === 'csv') && <span className='mandatory'>*</span>}
                    {t("resource_4:dataSeperatorForCsv")}
                  </Form.Label>
                
                    <Form.Control
                      size='sm'
                      {...register('dataSepratorforCSV', {
                        required: Array.isArray(watch('bulkfileExtension')) && watch('bulkfileExtension').some(ext => ext.toLowerCase() === 'csv') ? t('resource_3:isRequired', { field: t("resource_4:dataSeperatorForCsv") }) : false
                      })}
                      className={`fs--1 form-control ${
                        errors.dataSepratorforCSV ? 'is-invalid' : ''
                      }`}
                      type='text'
                      onChange={(e) => {
                        setValue(
                          'dataSepratorforCSV',
                          e.target.value,
                          { shouldValidate: true }
                        )
                        clearErrors('dataSepratorforCSV')
                              dispatch(setDirty())
                      }}
                      disabled={matchPathInstruction() && !submitEnable}
                      value={watch('dataSepratorforCSV')}
                    />
                
                  <div className='invalid-feedback'>
                    {errors.dataSepratorforCSV?.message?.toString()}
                  </div>
                </Form.Group>
              </div>
  )}

   {(watch('bulkfileExtension')?.includes("xlsx") || watch('bulkfileExtension')?.includes("xls")) && (
                    <div className='col-lg-4 mb-3' style={{ zIndex: 501 }}>
                      <Form.Group controlId='bulk.validTill'>
                        <Form.Label className='fs--1'>
                          <span className='mandatory'>*</span>

                          {t("resource_2:sheetNo")}
                        </Form.Label>
                        <div className='row'>
                          <div className='col-lg-12 mb-1'>
                            <Form.Control
                              size='sm'
                              {...register('sheetNo')}
                              className={`fs--1 form-control ${errors.sheetNo ? 'is-invalid' : ''
                                }`}
                              type='text'
                              onChange={(e) => {
                                {
                                  const value = e.target.value;
                                  if (/^[\d,\s]*$/.test(value)) {
                                    setValue('sheetNo', value, { shouldValidate: true });
                                  }
                                  clearErrors('sheetNo')
                                  dispatch(setDirty())
                                }
                              }}

                              onBlur={(e) => {
                                const trimmed = e.target.value.trim();
                                if (!trimmed) {
                                  setValue('sheetNo', '', { shouldValidate: true });
                                  
                                } else {
                                  setValue('sheetNo', trimmed, { shouldValidate: true });
                                }
                              }}
                              value={watch('sheetNo')}

                              disabled={matchPathInstruction() && !submitEnable ? true : false}


                            />
                            <div className='invalid-feedback'>
                              {errors.sheetNo?.message?.toString()}
                            </div>
                          </div>

                        </div>

                      </Form.Group>
                    </div>
                  )}



                    <div className='col-lg-8 offset-lg-2 mt-2 d-flex justify-content-center align-items-center'>
                    {  !matchPathInstruction()  || submitEnable == true? (    
                      <>    <Button
                      variant='falcon-primary me-2'
                      size='sm'
                      type='submit'
                      disabled={loading}
                  >
                      <FontAwesomeIcon icon={faSave} className='me-2' />
                      {t('resource_1:submit')}
                    </Button>
       
                    { !matchPathInstruction()  && (
                            <Button
                        variant='falcon-danger'
                        onClick={() => {
                          dispatch(clearFields({}));
                          resetForm();
                          setLoading(false)
                         
                       
                        }}
                        size='sm'>
                        <FontAwesomeIcon icon={faRedo} className='me-2' />
                        {t('resource_1:reset')}
                      </Button> )}
                      {submitEnable == true && matchPathInstruction() && 
                      <Button    onClick={() =>{setSubmitEnable(false);         setLoading(false);clearErrors()}}  variant='falcon-danger' size='sm'>
                              <FontAwesomeIcon icon={faEraser} className="me-2" />
                                            {t("resource_1:clear")}
                                          </Button>}
                      </>
                   ):""}
      {  matchPathInstruction() && submitEnable == false ? (<Button
                        variant="falcon-primary"
                        size="sm"
                        className="me-2"
                     onClick={() => setSubmitEnable(true)}
                      
                        
                      >
                        
                        <FontAwesomeIcon icon={faEdit} className="me-2" />
                        {t("resource_1:edit")}
                      </Button>):""}
                
                    </div>
        
       
            </div>
            </div>
            </div>
          </Form>
     
        </div>
      </Card.Body>
    </Card>
  );
};

export default BulkPayment;

